import F2 from "../Assets/Animations/F2.gif";
import F3 from "../Assets/Animations/F3.gif";
import F4 from "../Assets/Animations/F4.gif";
import F5 from "../Assets/Animations/F5.gif";
import F6 from "../Assets/Animations/F6.gif";
import F7 from "../Assets/Animations/F7.gif";
import F8 from "../Assets/Animations/F8.gif";
import F9 from "../Assets/Animations/F9.svg";

import aeroplane from "../Assets/Animations/aeroplane.json";
import parachutists from "../Assets/Animations/parachutists.json";
import rocket from "../Assets/Animations/rocket.json";

import darkAvatar from "../Assets/Images/darkAvatar.svg";

import FastWaterMarks from "../Assets/Images/FastWaterMarks.svg";
import ImageWaterMark from "../Assets/Images/ImageWaterMark.svg";
import fileWaterMarks from "../Assets/Images/fileWaterMarks.svg";
import fontsWaterMarks from "../Assets/Images/fontsWaterMarks.svg";
import logoWaterMarks from "../Assets/Images/logoWaterMarks.svg";
import textWaterMarks from "../Assets/Images/textWaterMarks.svg";

import dark from "../Assets/Images/dark-mode.svg";
import editingcontrol from "../Assets/Images/editing-control.svg";
import exif from "../Assets/Images/exif.svg";
import multiple from "../Assets/Images/export.svg";
import resolution from "../Assets/Images/high-quality-image.svg";
import multi from "../Assets/Images/multilingual.svg";
import qr from "../Assets/Images/qr-code.svg";
import friendly from "../Assets/Images/sleek-and-user-friendly.svg";
import trusted from "../Assets/Images/trusted-by-millions.svg";

export const Features = [
	{
		title: "WatermarkImageTitle",
		sub_title1: "WatermarkImageSubTitle1",
		sub_titlespan: "WatermarkImageSubTitleSpan",
		sub_title2: "WatermarkImageSubTitle2",
		description: "WatermarkImageDescription",
		extended: "WatermarkImageDescriptionExtended",
		image: F2,
		bg: "bgTest",
		landing: true,
	},
	{
		title: "BatchWatermarkingTitle",
		sub_title1: "BatchWatermarkingSubTitle1",
		sub_titlespan: "BatchWatermarkingSubTitleSpan",
		sub_title2: "BatchWatermarkingSubTitle2",
		description: "BatchWatermarkingDescription",
		extended: "BatchWatermarkingDescriptionExtended",
		image: F3,
		bg: "bgTest",
		landing: true,
	},
	{
		title: "TemplateCreationTitle",
		sub_title1: "TemplateCreationSubTitle1",
		sub_titlespan: "TemplateCreationSubTitleSpan",
		sub_title2: "TemplateCreationSubTitle2",
		description: "TemplateCreationDescription",
		extended: "TemplateCreationDescriptionExtended",
		image: F4,
		bg: "bgTest",
		landing: true,
	},
	{
		title: "CreativeTitle",
		sub_title1: "CreativeSubTitle",
		sub_titlespan: "CreativeSubTitleSpan",
		sub_title2: "CreativeSubTitle2",
		description: "CreativeDescription",
		image: F5,
		bg: "bgTest",
	},
	{
		title: "SignatureTitle",
		sub_title1: "SignatureSubTitle1",
		sub_titlespan: "SignatureSubTitleSpan",
		sub_title2: "SignatureSubTitle2",
		description: "SignatureDescription",
		image: F6,
		bg: "bgTest",
	},

	{
		title: "FontsTitle",
		sub_title1: "FontsSubTitle1",
		sub_titlespan: "FontsSubTitleSpan",
		sub_title2: "FontsSubTitle2",
		description: "FontsDescription",
		image: F7,
		bg: "bgTest",
	},
	{
		title: "LogoTitle",
		sub_title1: "LogoSubTitle1",
		sub_titlespan: "LogoSubTitleSpan",
		sub_title2: "LogoSubTitle2",
		description: "LogoDescription",
		image: F8,
		bg: "bgTest",
	},
	{
		title: "AppsTitle",
		sub_title1: "AppsSubTitle1",
		sub_titlespan: "AppsSubTitleSpan",
		sub_title2: "AppsSubTitle2",
		description: "AppsDescription",
		image: F9,
		bg: "bgTest",
	},
	// {
	//   title: "Title",
	//   sub_title1: "SubTitle1",
	//   sub_titlespan: "SubTitleSpan",
	//   sub_title2: "SubTitle2",
	//   description: "Description",
	//   image: F4,
	//   bg: "bgTest"

	// },
];

export const reviews = [
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
	{
		name: "Usama",
		img: darkAvatar,
		review:
			"After successfully signing-in.Click on the watermark multiple images on the home page.Then select template from the list of available templates then upload files. Guess what you will see, users are able to upload any type of files. In batch photos edit screen, where you will see the outcome from that file",
	},
];

export const faqs = [
	{
		question: "Q1",
		answer: "A1",
		type: "pricing",
	},
	{
		question: "Q2",
		answer: "A2",
		type: "pricing",
	},
	{
		question: "Q3",
		answer: "A3",
		type: "pricing",
	},
	{
		question: "Q4",
		answer: "A4",
		type: "pricing",
	},
	{
		question: "Q5",
		answer: "A5",
		type: "faq",
	},
	{
		question: "Q6",
		answer: "A6",
		type: "faq",
	},
	{
		question: "Q7",
		answer: "A7",
		type: "faq",
	},
	{
		question: "Q8",
		answer: "A8",
		type: "faq",
	},
	{
		question: "Q9",
		answer: "A9",
		type: "faq",
	},
	{
		question: "Q10",
		answer: "A10",
		type: "faq",
	},
	{
		question: "Q11",
		answer: "A11",
		type: "faq",
	},
	{
		question: "Q12",
		answer: "A12",
		type: "faq",
	},
	{
		question: "Q13",
		answer: "A13",
		type: "faq",
	},
	{
		question: "Q14",
		answer: "A14",
		type: "faq",
	},
	{
		question: "Q15",
		answer: "A15",
		type: "faq",
	},
	{
		question: "Q16",
		answer: "A16",
		type: "faq",
	},
	{
		question: "Q17",
		answer: "A17",
		type: "faq",
	},
	{
		question: "Q18",
		answer: "A18",
		type: "faq",
	},
	{
		question: "Q19",
		answer: "A19",
		type: "faq",
	},
	{
		question: "Q20",
		answer: "A20",
		type: "faq",
	},
];

export const plan = {
	freeplan: {
		title: "FreeTitle",
		price: "0",
		recommended: false,
		bullets: ["Free1", "Free2", "Free3", "Free4"],
		animation: parachutists,
	},
	premPlan: {
		title: "PremTitle",
		price: "10",
		recommended: true,
		bullets: ["Prem1", "Prem2", "Prem3", "Prem4", "Prem2"],
		animation: aeroplane,
	},
	enterprisePlan: {
		title: "EnterpriseTitle",
		price: "15",
		recommended: false,
		bullets: ["Enterprise1", "Enterprise2", "Enterprise3"],
		animation: rocket,
	},
};

export const MoreFeaturesPricing = [
	{
		title: "ImageWaterMarkPriceFeatureTitle",
		description: "ImageWaterMarkPriceFeature",
		img: ImageWaterMark,
	},
	{
		title: "TextWaterMarkPriceFeatureTitle",
		description: "TextWaterMarkPriceFeature",
		img: textWaterMarks,
	},
	{
		title: "LogoWaterMarkPriceFeatureTitle",
		description: "LogoWaterMarkPriceFeature",
		img: logoWaterMarks,
	},
	{
		title: "FontsWaterMarkPriceFeatureTitle",
		description: "FontsWaterMarkPriceFeature",
		img: fontsWaterMarks,
	},
	{
		title: "FilesWaterMarkPriceFeatureTitle",
		description: "FilesWaterMarkPriceFeature",
		img: fileWaterMarks,
	},
	{
		title: "FastWaterMarkPriceFeatureTitle",
		description: "FastWaterMarkPriceFeature",
		img: FastWaterMarks,
	},
];
export const MoreFeatures = [
	{
		title: "EditingTitle",
		description: "EditingFeature",
		img: editingcontrol,
	},
	{
		title: "QRTitle",
		description: "QRFeature",
		img: qr,
	},
	{
		title: "DarkTitle",
		description: "DarkFeature",
		img: dark,
	},
	{
		title: "MultilingualTitle",
		description: "MultilingualFeature",
		img: multi,
	},
	{
		title: "UserFriendlyTitle",
		description: "UserFriendlyFeature",
		img: friendly,
	},
	{
		title: "ResolutionTitle",
		description: "ResolutionFeature",
		img: resolution,
	},
	{
		title: "EXIFTitle",
		description: "EXIFFeature",
		img: exif,
	},
	{
		title: "TrustedTitle",
		description: "TrustedFeature",
		img: trusted,
	},
	{
		title: "MultipleTitle",
		description: "MultipleFeature",
		img: multiple,
	},
];
